<template>
  <list listTitle="Usuários" filterTitle="Listagem de usuários" :loading="usersFetching" :total="usersTotal" :typesListAvailable="['displayList']" :sortDefault="{ field: 'email', order: 'asc' }" :sortFields="['email']" @change="onChange">
    <loader :loading="loading"/>

    <button @click="linkItemFlag = true" slot="header-actions" class="hint hint--left btn btn--info" data-label="Vincular usuário">
      <i class="icon-plus icon-download2"/>
    </button>

    <template slot="filters">
      <form-group label="Email">
        <input class="form-input" v-model="options.email">
      </form-group>
    </template>

    <div class="l-col-12@md" v-for="user in users" :key="user" v-if="users.length">
      <user-card :user="user" :hasAdminAccess="hasAdminAccess"/>
    </div>

    <div class="l-col u-textCenter" v-if="!users.length">
      <panel>
        Nenhum usuário encontrado.
      </panel>
    </div>

    <modal-unlink v-model="unlinkItemFlag" v-on:option="unlink(unlinkItem)"/>
    <modal-user-roles v-model="userRolesFlag" :user="selectedUser" v-on:saveUserRoles="saveUserRoles"/>
    <modal-link-user v-model="linkItemFlag" v-on:search="searchUsers"/>
  </list>
</template>

<script>
  import { merge } from 'lodash'
  import { mapActions } from 'vuex'
  import OrderCard from '@/components/Order/Shared/OrderCard'
  import ModalLinkUser from '@/components/User/ModalLinkUser'
  import FormGroup from '@/components/template/FormGroup'
  import List from '@/components/shared/list/Paginator'
  import DateInput from '@/components/template/DateInput'
  import Panel from '@/components/template/Panel'
  import BulkActions from '@/components/shared/BulkActions'
  import UserCard from '@/components/User/Card'
  import api from '@/api'
  import ModalUnlink from '@/components/User/ModalUnlink'
  import ModalUserRoles from '@/components/User/ModalUserRoles'
  import VueTagsInput from '@johmun/vue-tags-input'
  import Loader from '@/components/template/Loader'
  import notifier from '@/notifier'

  export default {
    data: () => ({
      options: {
        email: ''
      },
      usersFetching: false,
      selectedAll: false,
      usersTotal: 0,
      users: [],
      unlinkItemFlag: false,
      unlinkItem: null,
      linkItemFlag: false,
      loading: false,
      userRolesFlag: false,
      selectedUser: null,
      hasAdminAccess: null
    }),
    async mounted () {
      let roleType = await api.userRoleAccess()

      if (roleType) {
        this.hasAdminAccess = (roleType.type === 'admin')

        if (!this.hasAdminAccess) {
          this.hasAdminAccess = (await api.isUserMerchantOwner() === true)
        }
      }
    },
    methods: {
      ...mapActions('user', [
        'unlinkUser'
      ]),
      async saveUserRoles (selectedRole) {
        api.updateUserRole(this.selectedUser.email, selectedRole)
          .then(() => {
            notifier.success('Permissões de usuário alteradas com sucesso!', 'Sucesso')
            setTimeout(() => {
              window.location.reload()
            }, 2000)
          })
          .catch(() => {
            notifier.error('Você não tem permissão para alterar grupos de usuário', 'Erro')
          })
      },
      async onChange (options) {
        merge(this.options, options)

        this.searchUsers()
      },
      async showModal (user) {
        this.unlinkItem = user

        this.unlinkItemFlag = true
      },
      async showModalUserRoles (user) {
        this.userRoles = user
        this.userRolesFlag = true
        this.selectedUser = user
      },
      async searchUsers () {
        this.loading = true

        try {
          const response = await api.getHubUsers(this.options)

          this.users = response.items
          this.usersTotal = response.total
        } catch (err) {
          this.users = []
        } finally {
          this.loading = false
        }
      },
      async unlink (user) {
        await this.unlinkUser(user)
        await this.searchUsers()
      }
    },
    components: {
      List,
      OrderCard,
      FormGroup,
      ModalLinkUser,
      DateInput,
      Panel,
      BulkActions,
      VueTagsInput,
      UserCard,
      ModalUnlink,
      Loader,
      ModalUserRoles
    }
  }
</script>

<style scoped lang="sass">
  .logo
    max-height: 30px
    margin-right: 20px

  .title
    margin-top: 16px
    margin-left: 20px

  .paginator
    float: right

  .count-selected
    margin-top: 3px

  .selectAll
    width: 48px
    padding: 16px

  .btn--default
    margin-right: 5px

  .inline-flex
    display: inline-flex

  .check-box
    border-color: #7872ff
</style>



// WEBPACK FOOTER //
// Base.vue?190994e4